// Simple encryption function for the token
const encrypt = (text) => {
  const base64 = btoa(text); // First convert to base64
  return base64
    .split('')
    .map(char => String.fromCharCode(char.charCodeAt(0) + 1))
    .join('');
};

// Generate token using current date
export const generateToken = () => {
  const date = new Date();
  const dateStr = date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  return encrypt(dateStr);
};

// Header key constant
export const TOKEN_HEADER = 'LWT_TOKEN';